import { faChevronLeft, faChevronRight, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";

import { SiteHeader } from "../../components/header/header";
import { SiteFooter } from "../../components/footer/footer";
import { formatImageUrl } from "../../_helpers/format-image-url";
import { NavComponent } from "../../components/header/nav-component";
import { UseCarContext } from "../../services/products/product.context";
import { UseCartList } from "../../services/cart/cart.context";
import { CartComponent } from "../saved/cart";

export const CarDetails = () => {

    const [openNav, setOpenNav] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);
    const [orderedQty, setOrderedQty] = useState(1);
    const [cartItem, setCartItem] = useState();

    const { someCars } = UseCarContext();
    const { saveToWishList, wishList, toggleCart, openCart } = UseCartList();

    const togglenavOpen = () => setOpenNav((st) => !st);

    const { car } = useLocation().state;
    const navigateTo = useNavigate();


    const handleIncreaseIndex = () => {
        if (imageIndex === car?.images.length - 1) {
            setImageIndex(0);
            return;
        }
        setImageIndex((i) => i + 1);
    }


    const handleDecreaseIndex = () => {
        if (imageIndex === 0) {
            setImageIndex(car?.images.length - 1);
            return;
        }
        setImageIndex((i) => i - 1);
    }

    const increaseQty = () => {
        setOrderedQty((qty) => qty + 1)
    }

    const decreaseQty = () => {
        if (orderedQty === 1) {
            return
        }
        setOrderedQty((qty) => qty - 1);
    }


    return (
        <div className="f-pg app-pg">
            <SiteHeader togglenavOpen={togglenavOpen} />
            <CartComponent
                inView={openCart}
                itemdata={cartItem}
                resetCart={() => setCartItem()}
            />
            <div className="details-section">
                <div className="details-slide-display">
                    <div className="index-selector">
                        <button
                            className="selector-button flx-cnt"
                            onClick={handleDecreaseIndex}
                        >
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <button
                            className="selector-button flx-cnt"
                            onClick={handleIncreaseIndex}
                        >
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </div>
                    <a
                        href={formatImageUrl(car?.images[imageIndex])}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src={formatImageUrl(car?.images[imageIndex])}
                            alt=""
                            className="detail-img"
                        />
                    </a>
                </div>
                <div className="scroll-preview">
                    {car?.images?.map((image, i) => (
                        <button className="tr-btn" key={i} onClick={() => setImageIndex(i)}>
                            <img
                                src={formatImageUrl(image)}
                                alt=""
                                className={classNames("image-frame", { chosen: imageIndex === i })}
                            />
                        </button>
                    ))}
                </div>
                <div className="car-infos">
                    <div className="car-brand">{car?.brand}</div>
                    <div className="car-model-yr">
                        <span className="car-model">{car?.model}</span>
                        <span className="car-yr">{car?.year}</span>
                    </div>
                    <div className="car-price">FCFA {car?.cost.toLocaleString()}</div>
                </div>
                <div className="order-quantity">
                    <button className="qty-button flx-cnt" onClick={decreaseQty}>
                        <FontAwesomeIcon icon={faMinus} />
                    </button>
                    <input type="number" value={orderedQty} className="qty-input" />
                    <button className="qty-button flx-cnt" onClick={increaseQty}>
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                </div>
                <div className="prop-box">
                    {car?.properties?.map((property, indx) => (
                        <div className="prop-unit">
                            <span className="prop-label">{Object.keys(property)[0]}</span>
                            <span className="prop-data">{Object.values(property)[0]}</span>
                        </div>
                    ))}
                </div>
                <div className="order-quantity">
                    <button
                        className="place-order-button"
                        onClick={() => navigateTo("/order", {
                            state: {
                                products: [{
                                    ...car,
                                    quantity: orderedQty
                                }],
                                total: car?.cost
                            }
                        })}
                    >
                        Place your order
                    </button>
                </div>
            </div>
            <SiteFooter />
        </div>
    );
}